import type { Course } from "~/models/course";
import { toPlainText } from "~/lib/seo/sanitise";


export function buildCourseSchema(course: Course) {
    return {
        "@context": "https://schema.org",
        "@type": "Course",
        name: course.name,
        description: toPlainText(course.shortDescription),
        provider: {
            "@type": "Organization",
            name: "Constellation Training",
            sameAs: "https://constellationtraining.co.uk",
        },
        educationalCredentialAwarded: course.credential ?? 'Certificate of Awareness',
        url: `https://constellationtraining.co.uk/courses/${course.tags[0].reference}/${course.reference}`,
    } as const;
}